import React from "react";
import MobileImageSection from "./MobileImageSection";

function MobileVideo({ resultArray }) {
  const array1 = resultArray[0];
  const array2 = resultArray[1];
  const array3 = resultArray[2];
  return (
    <div className="d-lg-none position-relative overflow-hidden pb-5">
      <div className="slide-horizontal d-flex st1">
        <MobileImageSection resultArray={array1} className="imgbox d-flex" />
        <MobileImageSection resultArray={array1} className="imgbox d-flex" />
        <MobileImageSection resultArray={array1} className="imgbox d-flex" />
      </div>
      <div className="slide-horizontal d-flex st2">
        <MobileImageSection resultArray={array2} className="imgbox d-flex" />
        <MobileImageSection resultArray={array2} className="imgbox d-flex" />
        <MobileImageSection resultArray={array2} className="imgbox d-flex" />
      </div>
      <div className="slide-horizontal d-flex st3">
        <MobileImageSection resultArray={array3} className="imgbox d-flex" />
        <MobileImageSection resultArray={array3} className="imgbox d-flex" />
        <MobileImageSection resultArray={array3} className="imgbox d-flex" />
      </div>
    </div>
  );
}
export default MobileVideo;
